exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-20b4e4ee] .modal-head{padding:16px 20px;border-bottom:1px solid #f1f1f1}.unusual-form .unusual-textarea[data-v-20b4e4ee]{border:1px solid #dcdfe6;resize:none;width:100%;height:150px;font-size:14px;padding:10px;color:#606266;border-radius:4px}.unusual-form .unusual-textarea[data-v-20b4e4ee]::placeholder{color:#999}.unusual-form[data-v-20b4e4ee] .el-form-item{display:flex}.unusual-form[data-v-20b4e4ee] .el-form-item .el-form-item__content{flex:1}.unusual-form[data-v-20b4e4ee] .el-form-item .el-form-item__content .el-input__inner{width:100%!important}.unusual-form[data-v-20b4e4ee] .el-form-item .el-select{width:100%}", ""]);

// exports
